export default __webpack_public_path__ + "static/media/logo2.aee52da6.svg";